import { isDev } from '@/config'

class Api {
  constructor ({ baseUrl }) {
    this._baseUrl = baseUrl
  }

  _getResponseData (res) {
    if (!res.ok) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(`Ошибка: ${res.status}`)
    }
    return res.json()
  }

  getInitData (host) {
    return fetch(`${this._baseUrl}/getInitSetting`, {
      method: 'POST',
      body: JSON.stringify({ host }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        return this._getResponseData(res)
      })
  }

  sendRequest (params) {
    return fetch(`${this._baseUrl}/handler`, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        return this._getResponseData(res)
      })
  }

  sendFormData (formData) {
    return fetch(`${this._baseUrl}/handler`, {
      method: 'POST',
      body: formData
    })
      .then((res) => {
        return this._getResponseData(res)
      })
  }

  sendFormDataWithParams (formData, params) {
    Object.entries(params).forEach(([key, value]) => formData.append(key, value))
    return this.sendFormData(formData)
  }
}

const Backend = new Api({
  baseUrl: isDev ? 'https://api.quiz.test.lego-car.ru' : 'https://api.quiz.lego-car.ru'
  // baseUrl: isDev ? 'https://api.quiz.lego-car.ru' : 'https://api.quiz.lego-car.ru'
})

export default Backend
